import { render, staticRenderFns } from "./ContentDate.vue?vue&type=template&id=2476b771&"
import script from "./ContentDate.vue?vue&type=script&lang=js&"
export * from "./ContentDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports